import { useContext } from "react";
import NavContext from "../context/NavProvider";

const useNavProps = () => {
  return useContext(NavContext);  
}

export default useNavProps